import { listingRequest } from '@/requests/listingRequest';
import { useState } from 'react';
import { useMergedRequest } from './useMergedRequest';
const serializeAppliedFiltersToUrl = (appliedFilters) => {
    const params = new URLSearchParams();
    appliedFilters.forEach((filter) => {
        params.append(filter.filterKey, filter.key);
    });
    window.history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);
};
const getAppliedFiltersFromInitialData = (initialData) => {
    const appliedFilters = [];
    initialData.filters.forEach((filter) => {
        filter.values.forEach((value) => {
            if (value.isActive) {
                appliedFilters.push({
                    label: value.label,
                    filterKey: filter.key,
                    key: value.key,
                });
            }
        });
    });
    return appliedFilters;
};
export function useListing({ facetsToShow, initialData, parentPage, searchEndpoint, sort, }) {
    const initialPage = Math.floor(initialData.from / initialData.pageSize);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(getAppliedFiltersFromInitialData(initialData));
    const [page, setPage] = useState(initialPage);
    const { response, status } = useMergedRequest({
        request: async () => listingRequest(searchEndpoint, {
            facetsToShow,
            parentPage,
            page,
            pageSize: initialData.pageSize,
            filters: appliedFilters,
            sort,
        }),
        initial: initialData,
        deps: [appliedFilters, page],
        merge: (existing, response) => {
            const isFresh = response.from === 0;
            return {
                items: [...(isFresh ? [] : (existing?.items ?? [])), ...response.items],
                total: response.total,
                filters: response.filters,
                hasNextPage: response.items.length >= initialData.pageSize,
            };
        },
    });
    const applyFilters = (values) => {
        setPage(initialPage);
        setIsFilterOpen(false);
        setAppliedFilters(values);
        serializeAppliedFiltersToUrl(values);
    };
    const nextPage = () => setPage((page) => page + 1);
    const key = `listings-${response.items.map((item) => JSON.stringify(item.dataObject)).join('-')}`;
    return {
        key,
        allAmount: response.total,
        appliedFilters,
        applyFilters,
        closeFilter: () => setIsFilterOpen(false),
        nextPage,
        hasNextPage: response.hasNextPage,
        filters: initialData.filters,
        isFilterOpen,
        items: response.items,
        openFilter: () => setIsFilterOpen(true),
        status,
    };
}
